module.exports = __webpack_public_path__ + "static/media/micInactive.a1e00064.svg";